import Data from 'react-k2-api/Api/Data'
import PrimaryKey from 'react-k2-api/Api/PrimaryKey'
import { Type } from 'class-transformer'
import TSpecialStringListDM from './TSpecialStringListDM'
import TArticleDM from './TArticleDM'

/**
 * Auta - Sazby
 */
export default class TVehicleRateDM extends Data {
	public static className = 'TVehicleRateDM'
	public static primaryKey = 'RID'
	public static systemFields = [
		'TimeStamp',
		'RecordID',
	]

	public getPrimaryKey(): PrimaryKey {
		return this.RID!
	}

	public static isHeader = false

	/**
	 * Časové razítko
	 */
	TimeStamp?: string

	/**
	 * Popis
	 */
	Description?: string

	/**
	 * Auto
	 */
	VehicleId?: number

	/**
	 * Číslo
	 */
	RID?: number

	/**
	 * undefined
	 */
	RecordMod?: number

	/**
	 * undefined
	 */
	RecordES?: number

	/**
	 * Číslo
	 */
	RecordID?: number

	/**
	 * undefined
	 */
	RecordState?: number

	/**
	 * s
	 */
	SelectionImgCalc?: string

	/**
	 * LegislationContext
	 */
	LegislationContextCalc?: number

	/**
	 * Datum
	 */
	CurrentDateCalc?: Date

	/**
	 * Čas
	 */
	CurrentTimeCalc?: Date

	/**
	 * Vykládka
	 */
	@Type(() => TSpecialStringListDM)
	Unload?: TSpecialStringListDM

	/**
	 * Nakládka
	 */
	@Type(() => TSpecialStringListDM)
	Load?: TSpecialStringListDM

	/**
	 * Rovnice
	 */
	@Type(() => TSpecialStringListDM)
	Equation?: TSpecialStringListDM

	/**
	 * Typ jízdy
	 */
	@Type(() => TSpecialStringListDM)
	RideType?: TSpecialStringListDM

	/**
	 * Zboží
	 */
	@Type(() => TArticleDM)
	ArticleId?: TArticleDM
}